import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  AfterViewInit,
  ElementRef,
  Type,
} from '@angular/core';
import {
  Validators,
  FormBuilder,
  FormGroup,
  FormArray,
  FormControl,
} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { AppState } from '../../../../app.reducer';
import { Store } from '@ngrx/store';
import {
  GetThemes,
  GetTagList,
  GetDocumentById,
  ResourcesActionTypes,
  SubmitForApproval,
  AddDocument,
  UpdateDocument,
  AddNewVersion,
  GetDocumentVersionDetails,
  GetUserCapabilitesOfDocument,
  PublishDocument,
  GetFileByIdStart,
  UPDATEDOCUMENTSTARTACTION,
  GetAsOfVersionStartAction,
  ClearDocDetailsStartAction,
  CancelActivityLogStartForDocument
} from '../_store/resources.actions';
import { MatCheckbox, MatDialog, MatChipInputEvent, MatAutocomplete, } from '@angular/material';
import { Subject } from 'rxjs';
import { takeUntil, take, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Actions } from '@ngrx/effects';
import { API } from 'src/app/services/Api.service';
import { NotificationsService } from 'angular2-notifications';
import { environment } from '../../../../../environments/environment';
import { NotificationModalComponent } from '../../../common-components/notification-modal/notification-modal.component';
export const BASE_URL = environment.host;
import { AddTagStartAction, GetAllTagsListStartAction, ClearTagAction } from '../../tasks/store/tasks.actions';
import { ENTER, COMMA } from "@angular/cdk/keycodes";
import { ErrorAction } from 'src/app/login/store/auth.actions';
import { LoaderShow } from "../../../loader/store/loader.actions";
import { GetConfigurations } from '../../configurations/store/configurations.actions';
import { ValidationUtil, VALIDATION_MESSAGES } from "../../../../utils/validation.util";
import { ACCEPTED_FILE_TYPES, ACCEPTED_FILE_TYPES_TEXT, MIME_TYPE_ON_EXTENSION } from 'src/app/app.constants';

@Component({
  selector: 'upload-document',
  templateUrl: './upload-document.component.html',
  styleUrls: ['./upload-document.component.scss']
})

export class UploadDocumentComponent implements OnInit, OnDestroy, AfterViewInit {

  documentId;
  currentVersion;
  addNewVersion = false;
  existingThemes: Array<any> = [];
  form: FormGroup;
  themeList$;
  themesFormArray: FormArray;
  tagList$;
  fileName = '';
  showFilePond = true;
  isPublish = false;
  maxFileSizeExceeded: boolean = false;
  hasErrorInFile = false;
  errorMsgForFile = '';

  specialCharregex = new RegExp(/[A-Za-z0-9]*$/);
  multiSpaceRegex = new RegExp(/\w*[ ]{2,}\w*$/);
  separatorKeysCodes: number[] = [ENTER, COMMA];
  error = false;
  stopper$: Subject<any> = new Subject();
  validationMsg = VALIDATION_MESSAGES;
  regExError: boolean = false
  originalValues
  firstCheckIn: boolean = true
  submitDisabled: boolean = true

  @ViewChild('myPond', { static: false }) public myPond: any;
  @ViewChild('myPond2', { static: false }) public myPond2: any;
  @ViewChild('auto', { static: false }) matAutocomplete: MatAutocomplete;
  @ViewChild('tagInput', { static: false }) tagInput: ElementRef<HTMLInputElement>;
  @ViewChild('myForm', { static: false }) myForm;


  pondOptions: any = {
    name: 'upfile',
    class: 'my-filepond',
    multiple: false,
    labelIdle: 'Drag or Upload File here',
    // maxFileSize: '1KB',
    allowFileSizeValidation: true,
    labelMaxFileSizeExceeded: 'File is too large',
    fileValidateTypeLabelExpectedTypes: ['Allowed file formats: {allTypes}'],
    acceptedFileTypes: ACCEPTED_FILE_TYPES,
    fileValidateTypeLabelExpectedTypesMap: ACCEPTED_FILE_TYPES_TEXT,
    fileValidateTypeDetectType: (source, type) => new Promise((resolve, reject) => {
      console.log("originalType", type);
      if (type === "") {
        let fileExtension = source.name.split('.').pop();
        console.log("resolvedType", MIME_TYPE_ON_EXTENSION(fileExtension));
        resolve(MIME_TYPE_ON_EXTENSION(fileExtension));
      } else {
        resolve(type);
      }
    })
  };

  pondFiles = [];
  fileToUpload: any = {};
  isFileReplaced: boolean = false;
  uploadStarted = false;
  accessToken: any;
  userCapability: Array<string> = [];
  docDetail: any;
  addTag: boolean = false;
  // responseTags: any[] =[];
  selectedTags: any = [];
  selectedTagWithId: any;
  selectedTagIds: any = [];
  tagsList: any = [];
  removable = true;
  noFileName: boolean = false;
  formData: FormData = new FormData();
  updateCall: boolean = false;
  documentFormdata = new FormData();
  clearAction: boolean = false;
  folderId: string = '';
  isCitis: boolean = false;
  filePresent: boolean = false;
  documentObj: any = {};
  MaxSizeAllowed: number = 0;
  actualFileSize: number = 0;
  searchString;
  citisFolderId: any;
  documentTypes = [{ name: "Main Document", key: "main-document" }, { name: "Annexures", key: "annexures" }, { name: "KML", key: "kml" }, { name: "Figures", key: "figures" }]
  constructor(
    public location: Location,
    private fb: FormBuilder,
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private action$: Actions,
    private api: API,
    private notificationService: NotificationsService,
    private router: Router,
    private dialog: MatDialog,
  ) {
    this.route.params.subscribe(params => {
      this.folderId = params.id
      this.isCitis = this.router.url.includes('citiis');
    });
    this.form = this.fb.group({
      name: ['', Validators.compose([
        Validators.required,
        ValidationUtil.cannotBeBlank,
        Validators.pattern('(.*)([a-zA-Z0-9])(.*)$')
        // Validators.pattern('^[a-zA-Z0-9 ]+$')
      ])],
      description: [''],
      tags: [''],
      summary: [''],
      type: ['']
    });
  }

  ngOnInit() {

    /* TODO:: This piece of code seems to be not useless, so commenting it out */
    /* this.form.controls.description.valueChanges.subscribe((val) => { 
      console.log(this.form.controls.description);
    }); */

    this.store.dispatch(new GetConfigurations());
    this.store.dispatch(new ClearDocDetailsStartAction())
    this.store.select(state => state.resources.userCapability).subscribe(data => {
      return this.userCapability = data
    });

    this.store.dispatch(new ClearTagAction());
    this.tagList$ = this.store.select(state => state.resources.tags);
    this.store.select(state => state.auth).pipe(take(1)).subscribe(auth => {
      this.accessToken = auth.accessToken;
    });
    this.store.select(state => state.resources.docDetail).pipe(takeUntil(this.stopper$)).subscribe(detail => {
      if (!this.clearAction) {
        this.updateCall = true;
        this.docDetail = detail;
        this.fileName = (detail || {}).fileName || '';
        this.showFilePond = !this.fileName ? true : false;
        this.form.patchValue({
          name: detail.name || '',
          description: detail.description || '',
          summary: detail.summaryObservations || '',
          type: detail.documentType || '',
          // tags: detail.tags.map(tag => tag.tag) || [],
        });
        this.selectedTags = (detail.tags || []).map(tag => tag.tag) || [];
        this.selectedTagIds = (detail.tags || []).map(tag => tag._id) || [];
        if (Object.keys(detail).length) {
          this.filePresent = true;
        }
      } else {
        this.fileName = '';
        this.showFilePond = true;
        this.updateCall = false
        this.form.patchValue({
          name: '',
          description: ''
        })
        this.selectedTagIds = [];
      }
    });

    /* check if edit mode */
    this.route.params.subscribe(params => {
      this.documentId = (params || {}).documentId;
      this.citisFolderId = (params || {}).folderId;
      if (this.documentId) {
        this.currentVersion = (params || {}).currentVersion;
        this.isPublish = ((params || {}).action || ' ').includes('publish');
        if (this.isPublish) {
          this.store.dispatch(new GetDocumentById(this.documentId));
        } else {
          this.store.dispatch(new GetDocumentById(this.documentId));
          this.store.dispatch(new GetUserCapabilitesOfDocument(this.documentId));
        }
      }
      if (!Object.keys(params).length) {
        // clear doc details here
        //doc call for clearing all doc etails
        this.clearAction = true;
        this.store.dispatch(new ClearDocDetailsStartAction())
      }
    });
    //action for  Add Document
    // this.action$.pipe(
    //   ofType(ResourcesActionTypes.ADD_DOCUMENT),
    //   switchMap((action: AddDocument) => {
    //     if (!action.payload) {
    //       this.location.back();
    //       return;
    //     }
    //     return this.api.uploadNewDocument(action.payload).pipe(
    //       takeUntil(this.stopper),
    //       map((response: any) => {
    //         if (response.doc_id) {
    //           this.startFileUpload(response.doc_id, response.version_id);
    //         }
    //       }),
    //       catchError(err => {
    //         this.notificationService.error(err.error);
    //         return of({ type: '' });
    //       })
    //     );
    //   })
    // ).pipe(takeUntil(this.stopper)).subscribe();
    // update document
    // this.action$.pipe(
    //   ofType(ResourcesActionTypes.UPDATE_DOCUMENT),
    //   switchMap((action: UpdateDocument) => {
    //     return this.api.updateDocument(action.id, action.version, action.payload).pipe(
    //       takeUntil(this.stopper),
    //       map((response: any) => {
    //         if (response._id) {
    //           if (this.uploadStarted) {
    //             return;
    //           }
    //           if (this.isFileReplaced) {
    //             this.uploadStarted = true;
    //             this.startFileUpload(this.documentId, response._id);
    //           } else {
    //             this.notificationService.success('Document Updated Successfully');
    //             //this.store.dispatch(new GetDocumentById(this.documentId));
    //             this.location.back();
    //             // this.router.navigateByUrl('home/resources/me');
    //           }
    //         }
    //       }),
    //       catchError(err => {
    //         this.notificationService.error(err.error);
    //         return of({ type: '' });
    //       })
    //     );
    //   })
    // ).pipe(takeUntil(this.stopper)).subscribe();


    // publishing document
    // this.action$.pipe(dialog
    //   ofType(ResourcesActionTypes.PUBLISH_DOCUMENT),
    //   switchMap((action: PublishDocument) => {
    //     return this.api.publishDocument(action.docId, action.payload).pipe(
    //       map((response: any) => {
    //         this.notificationService.success(`Document published successfully.`);
    //         return this.router.navigateByUrl('home/resources/me');
    //       }),
    //       catchError(err => {
    //         this.notificationService.error(err.error);
    //         return of({ type: '' });
    //       })
    //     );
    //   }),
    //   takeUntil(this.stopper)
    // ).subscribe();

    //FilePond.registerPlugin(FilePondPluginFileValidateSize);

    this.form.controls.tags.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe((value) => {
      this.searchString = value;


      this.error = false;
      this.regExError = false;

      if (value != null) {

        (typeof (value) === 'number') ? value.toString() : value;
        let trimmedVal = value.trim();
        if (trimmedVal.length) {
          // this.specialCharregex = new RegExp(/(.*)([a-zA-Z0-9])(.*)$/);
          // this.multiSpaceRegex = new RegExp(/[ ]{2,}/);
          // if (this.specialCharregex.test(value) && !this.multiSpaceRegex.test(value)) {
          //   this.store.dispatch(new GetAllTagsListStartAction({ 'search': trimmedVal }))
          // } else {
          //   // invalid tag
          //   this.tagsList = []
          //   this.error = true;
          // }

          this.specialCharregex = new RegExp(/^[A-Za-z0-9 ]*[A-Za-z0-9][A-Za-z0-9 ]*$/);
          this.multiSpaceRegex = new RegExp(/[ ]{2,}/);

          if (this.specialCharregex.test(value)) {
            let value = trimmedVal.trim();
            this.store.dispatch(new GetAllTagsListStartAction({ 'search': value }))
          }
          else {
            this.tagsList = []
            this.error = false;
            this.regExError = true;
          }

          if (!this.multiSpaceRegex.test(value)) {
            let value = trimmedVal.trim();
            this.store.dispatch(new GetAllTagsListStartAction({ 'search': value }))
          }
          else {
            this.tagsList = []
            this.regExError = false;
            this.error = true;
          }
        } else {
          this.tagsList = []
        }
      }
    });

    this.store.select(state => state.tasks.tagsList).subscribe((taglist) => {
      if (this.searchString && (!this.error && !this.regExError)) {
        taglist.unshift({ tag: ` + Create tag for '${this.searchString}'` });
      }


      this.tagsList = taglist.filter((tag) => !this.selectedTagIds.includes(tag._id));
      if (taglist.length) {
        this.addTag = false;
      } else {
        this.addTag = true;
      }
    });

    this.store.select(state => state.tasks.addedTag).subscribe((response) => {
      //check for response when added new tag
      if (Object.keys(response).length) {
        let data = response;
        let index = this.selectedTags.findIndex(tag => tag === response.tag);
        if (index === -1) {
          this.selectedTags.push(response.tag);
          this.selectedTagIds.push(data._id);
          // this.store.dispatch(new ClearTagAction());
          this.tagsList = []
        }
      }
    });
    this.tagsList = [];
    // // effect for update document 
    // this.action$.pipe(
    //   ofType(ResourcesActionTypes.UPDATE_DOCUMENT_START_ACTION),
    //   switchMap((action: UPDATEDOCUMENTSTARTACTION) => {
    //     if(action.callType === 'update') {
    //       alert(this.calledOnce);
    //       if(this.calledOnce) return
    //       this.calledOnce =true
    //         return this.api.updateDocumentDetails(action.payload, action.id).pipe(
    //         map((response: any) => {
    //             this.notificationService.success(`Document updated successfully.`);
    //              this.router.navigateByUrl('home/resources/me');
    //             return new GetAsOfVersionStartAction(action.id);

    //         }),
    //       catchError(err => {
    //           return of(new ErrorAction(err));
    //       }));
    //     }
    //     return of('')
    //   })
    // ).subscribe()

    // this.store.select(state => state.resources.file).subscribe(fileData => {
    //   console.log(fileData, "data")
    //   this.fileToUpload = fileData;
    // });
    this.store.select(state => state.configurations.configurations).pipe(takeUntil(this.stopper$)).subscribe((resp: any) => {
      if (Object.keys(resp).length) {
        this.documentObj = Object.assign({}, resp);
        console.log("DocumentOBj", this.documentObj);
        this.documentObj['documentName'] = resp['docNameLength'].displayName;
        this.documentObj['documentNameLength'] = parseInt(resp['docNameLength'].value);
        this.documentObj['documentDescriptionSize'] = parseInt(resp['docDescriptionSize'].value);
        this.MaxSizeAllowed = parseInt(resp['docSize'].value) * 1024 * 1024;
        console.log(this.pondOptions);
        this.pondOptions.maxFileSize = resp['docSize'].value + 'MB';
        this.pondOptions.labelMaxFileSize = `Maximum file size allowed is ${resp['docSize'].value}MB`;
        if (this.myPond) {
          this.myPond.pond.maxFileSize = this.MaxSizeAllowed;
          this.myPond.pond.labelMaxFileSize = `Maximum file size allowed is ${resp['docSize'].value} MB`;
        }

        let validators = [Validators.maxLength(parseInt(resp['docNameLength'].value))];
        let docNameValidator = [Validators.maxLength(parseInt(resp['docDescriptionSize'].value))]
        this.form.get('name').setValidators([Validators.required, ValidationUtil.cannotBeBlank,
        Validators.pattern('(.*)([a-zA-Z0-9])(.*)$'),
        ...validators]);
        this.form.get('description').setValidators([...docNameValidator]);

        this.originalValues = Object.assign({}, this.form.value)
      }
    })

    this.form.valueChanges
      .pipe(debounceTime(500))
      .subscribe(data => {
        console.log(this.originalValues, data)
        if (!this.firstCheckIn)
          for (var k in data) {
            if (this.originalValues[k] != data[k]) {
              this.submitDisabled = false
              break
            }
            else
              this.submitDisabled = true
          }
        this.firstCheckIn = false

        console.log(this.submitDisabled, this.firstCheckIn)
      })
  }

  ngAfterViewInit() {
    this.form.valueChanges
      .pipe(debounceTime(500))
      .subscribe(data => {
        console.log('Form changes', data)
        for (var propt in data) {
          console.log(data[propt]);
        }
      })

  }

  onThemeChange(checkbox: MatCheckbox, themeId: string) {
    if (checkbox.checked) {
      this.themesFormArray.push(new FormControl(themeId));
    } else {
      const index = this.themesFormArray.controls.findIndex(
        x => x.value === themeId
      );
      this.themesFormArray.removeAt(index);
    }
  }

  pondHandleInit() {
    console.log('FilePond has initialised', this.myPond);
  }

  pondHandleAddFile(event: any) {
    console.log("--------->", event.file)
    this.pondFiles.push(event.file.file);
    if (event.error) {
      this.hasErrorInFile = true;
      this.errorMsgForFile = event.error.sub;
    } else {
      this.hasErrorInFile = false;
    }
    if (this.fileName) {
      this.isFileReplaced = true;
      this.noFileName = false;
    }
    console.log("event", event);
    console.log("event file", event.file);
    if (event.file.file.size > this.MaxSizeAllowed) {
      this.maxFileSizeExceeded = true;
      this.noFileName = false;
      const fileSize = Number(event.file.file.size / 1048576);
      this.actualFileSize = ((fileSize % 1) === 0) ? fileSize : +fileSize.toFixed(2);
    } else {
      this.maxFileSizeExceeded = false;
      this.fileToUpload = event.file.file;
      this.isFileReplaced = true;
      this.noFileName = false;
      this.showFilePond = true;
      this.filePresent = true;
      this.submitDisabled = false
      this.fileName = event.file.file.name;
    }
  }

  pondFileRemoved(event: any) {
    this.hasErrorInFile = false;
    if (this.fileName) {
      this.isFileReplaced = false;
      // this.noFileName = false;
    } else {
      this.fileToUpload = {}
    }
    this.maxFileSizeExceeded = false;
    this.fileName = '';
    this.noFileName = true;
    this.filePresent = false;
    this.showFilePond = true;
  }

  // get getSelectedTags() {
  //   const selectedTags = this.form.get('tags').value;
  //   // console.log(selectedTags, "tags")
  //   let tags;
  //   this.tagList$.subscribe(tagList => {
  //     tags = tagList.filter(tag => {
  //       return selectedTags.includes(tag._id);
  //     });
  //   });
  //   return tags;
  // }

  // removeTag(selectedTag) {
  //   const tags = this.form.get('tags').value.filter(tag => tag !== selectedTag._id);
  //   this.form.get('tags').setValue(tags);
  // }

  doSubmit() {
    if (this.hasErrorInFile) return;
    if (this.maxFileSizeExceeded) return;
    let documentFormdata = new FormData();
    if (this.filePresent) {
      this.noFileName = false;
    } else {
      this.noFileName = true;
      return;
    }

    if (this.form.invalid) {
      return;
    }

    const data = this.form.value;
    documentFormdata.append('docName', data.name.trim());
    documentFormdata.append('description', data.description.trim());
    documentFormdata.append('summaryObservations', data.summary.trim());
    documentFormdata.append('documentType', data.type.trim());
    if (this.documentId) {
      console.log("In If");
      if (!this.isPublish) {
        if (this.isFileReplaced) {
          if (!this.filePresent) {
            return;
          }
          documentFormdata.append('upfile', this.fileToUpload);
          this.store.dispatch(new LoaderShow());
          this.store.dispatch(new UPDATEDOCUMENTSTARTACTION(documentFormdata, this.docDetail.parentId || this.documentId, 'update'));

          this.store.select(store => store.resources.updateDocument).subscribe(res => {
            if (res) {
              this.location.back();
              this.store.dispatch(new CancelActivityLogStartForDocument(this.docDetail.parentId || res));
              return;
            }
          });

        } else {
          this.store.dispatch(new LoaderShow());
          // console.log(documentFormdata)
          this.store.dispatch(new UPDATEDOCUMENTSTARTACTION(documentFormdata, this.docDetail.parentId || this.documentId, 'update'));
          this.store.select(store => store.resources.updateDocument).subscribe(res => {
            if (res) {
              this.location.back();
              this.store.dispatch(new CancelActivityLogStartForDocument(this.docDetail.parentId || res));
              return;
            }
          });


        }
      } else {
        let payload = {
          name: data.name,
          description: data.description,
          tags: this.selectedTagIds,
          folderId: (this.citisFolderId && this.citisFolderId != 'undefined' && this.citisFolderId != undefined) ? this.citisFolderId : null
        }
        this.publishDocument(payload);
      }
    } else {
      console.log("In else");
      // now call the api for documentId
      if (this.noFileName) return;
      this.formData = new FormData();
      this.formData.append('upfile', this.fileToUpload);
      this.formData.append('docName', data.name);
      this.formData.append('tags', this.selectedTagIds);
      this.formData.append('description', data.description);
      this.formData.append('summaryObservations', data.summary);
      this.formData.append('documentType', data.type);
      if (this.folderId) {
        this.formData.append('folderId', this.folderId);
      }
      this.store.dispatch(new LoaderShow());
      this.store.dispatch(new AddDocument(this.formData, "addDocument", this.isCitis));
      // new Response(this.formData).text().then(console.log)
      // this.api.uploadNewDocument(this.formData)
    }
  }

  publishDocument(payload) {
    const dialogRef = this.dialog.open(NotificationModalComponent, {
      width: '40%',
      panelClass: 'cmp-modal',
      data: {
        text: 'Are you sure you want to publish this document?',
        type: 'publishDoc'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.store.dispatch(new PublishDocument(this.docDetail.parentId || this.documentId, payload));
      }
    });
  }

  // startFileUpload(docId, verisonId) {
  //   const that = this;
  //   that.myPond.pond.setOptions({
  //     server: {
  //       process: (fieldName, file, metadata, load, error, progress, abort) => {
  //         const formData = new FormData();
  //         formData.append(fieldName, file, file.name);
  //         const request = new XMLHttpRequest();
  //         request.open('POST', `${BASE_URL}/docs/${docId}/file`);
  //         request.setRequestHeader('authorization', `Bearer ${this.accessToken}`);

  //         // Should call the progress method to update the progress to 100% before calling load
  //         // Setting computable to false switches the loading indicator to infinite mode
  //         request.upload.onprogress = (e) => {
  //           /* console.log('onProgress', e); */
  //           progress(e.lengthComputable, e.loaded, e.total);
  //         };

  //         // Should call the load method when done and pass the returned server file id
  //         // this server file id is then used later on when reverting or restoring a file
  //         // so your server knows which file to return without exposing that info to the client
  //         request.onload = function () {
  //           that.uploadStarted = false;
  //           if (request.status >= 200 && request.status < 300) {
  //             console.log('onLoadSuccess', request.responseText);
  //             // the load method accepts either a string (id) or an object
  //             if (that.documentId) {
  //               that.store.dispatch(new GetDocumentById(that.documentId));
  //               that.location.back();
  //               // that.router.navigateByUrl(`home/resources/doc/${that.documentId}`);
  //               return;
  //             }
  //             that.store.dispatch(new SubmitForApproval(docId, verisonId));
  //             load(request.responseText);
  //           } else {
  //             console.log('onLoadError', request.responseText);
  //             // Can call the error method if something is wrong, should exit after
  //             error('oh no');
  //           }
  //         };  // // effect for update document 
  // this.action$.pipe(
  //   ofType(ResourcesActionTypes.UPDATE_DOCUMENT_START_ACTION),
  //   switchMap((action: UPDATEDOCUMENTSTARTACTION) => {
  //     if(action.callType === 'update') {
  //       alert(this.calledOnce);
  //       if(this.calledOnce) return
  //       this.calledOnce =true
  //         return this.api.updateDocumentDetails(action.payload, action.id).pipe(
  //         map((response: any) => {
  //             this.notificationService.success(`Document updated successfully.`);
  //              this.router.navigateByUrl('home/resources/me');
  //             return new GetAsOfVersionStartAction(action.id);

  //         }),
  //       catchError(err => {
  //           return of(new ErrorAction(err));
  //       }));
  //     }
  //     return of('')
  //   })
  // ).subscribe()

  //         re  // // effect for update document 
  // this.action$.pipe(
  //   ofType(ResourcesActionTypes.UPDATE_DOCUMENT_START_ACTION),
  //   switchMap((action: UPDATEDOCUMENTSTARTACTION) => {
  //     if(action.callType === 'update') {
  //       alert(this.calledOnce);
  //       if(this.calledOnce) return
  //       this.calledOnce =true
  //         return this.api.updateDocumentDetails(action.payload, action.id).pipe(
  //         map((response: any) => {
  //             this.notificationService.success(`Document updated successfully.`);
  //              this.router.navigateByUrl('home/resources/me');
  //             return new   // // effect for update document 
  // this.action$.pipe(
  //   ofType(ResourcesActionTypes.UPDATE_DOCUMENT_START_ACTION),
  //   switchMap((action: UPDATEDOCUMENTSTARTACTION) => {
  //     if(action.callType === 'update') {
  //       alert(this.calledOnce);
  //       if(this.calledOnce) return
  //       this.calledOnce =true
  //         return this.api.updateDocumentDetails(action.payload, action.id).pipe(
  //         map((response: any) => {
  //             this.notificationService.success(`Document updated successfully.`);
  //              this.router.navigateByUrl('home/resources/me');
  //             return new GetAsOfVersionStartAction(action.id);

  //         }),
  //       catchError(err => {
  //           return of(new ErrorAction(err));
  //       }));
  //     }
  //     return of('')
  //   })
  // ).subscribe()GetAsOfVersionStartAction(action.id);
  // // effect for update document 
  // this.action$.pipe(
  //   ofType(ResourcesActionTypes.UPDATE_DOCUMENT_START_ACTION),
  //   switchMap((action: UPDATEDOCUMENTSTARTACTION) => {
  //     if(action.callType   // // effect for update document 
  // this.action$.pipe(
  //   ofType(ResourcesActionTypes.UPDATE_DOCUMENT_START_ACTION),
  //   switchMap((action: UPDATEDOCUMENTSTARTACTION) => {
  //     if(action.callType === 'update') {
  //       alert(this.calledOnce);
  //       if(this.calledOnce) return
  //       this.calledOnce =true
  //         return this.api.updateDocumentDetails(action.payload, action.id).pipe(
  //         map((response: any) => {
  //             this.notificationService.success(`Document updated successfully.`);
  //              this.router.navigateByUrl('home/resources/me');
  //             return new GetAsOfVersionStartAction(action.id);

  //         }),
  //       catchError(err => {
  //           return of(new ErrorAction(err));
  //       }));
  //     }
  //     return of('')
  //   })
  // ).subscribe()== 'update') {
  //       alert(this.called  // // effect for update document 
  // this.action$.pipe(
  //   ofType(ResourcesActionTypes.UPDATE_DOCUMENT_START_ACTION),
  //   switchMap((action: UPDATEDOCUMENTSTARTACTION) => {
  //     if(action.callType === 'update') {
  //       alert(this.calledOnce);
  //       if(this.calledOnce) return
  //       this.calledOnce =true
  //         return this.api.updateDocumentDetails(action.payload, action.id).pipe(
  //         map((response: any) => {
  //             this.notificationService.success(`Document updated successfully.`);
  //              this.router.navigateByUrl('home/resources/me');
  //             return new GetAsOfVersionStartAction(action.id);
  // // effect for update document 
  // this.action$.pipe(
  //   ofType(ResourcesActionTypes.UPDATE_DOCUMENT_START_ACTION),
  //   switchMap((action: UPDATEDOCUMENTSTARTACTION) => {
  //     if(action.callType === 'update') {
  //       alert(this.calledOnce);
  //       if(this.calledOnce) return
  //       this.calledOnce =true
  //         return this.api.updateDocumentDetails(action.payload, action.id).pipe(
  //         map((response: any) => {
  //             this.notificationService.success(`Document updated successfully.`);
  //              this.router.navigateByUrl('home/resources/me');
  //             return new GetAsOfVersionStartAction(action.id);

  //         }),
  //       catchError(err => {
  //           return of(new ErrorAction(err));
  //       }));
  //     }
  //     return of('')
  //   })
  // ).subscribe()
  //          // // effect for update document 
  // this.action$.pipe(
  //   ofType(ResourcesActionTypes.UPDATE_DOCUMENT_START_ACTION),
  //   switchMap((action: UPDATEDOCUMENTSTARTACTION) => {
  //     if(action.callType === 'update') {
  //       alert(this.calledOnce);
  //       if(this.calledOnce) return
  //       this.calledOnce =true
  //         return this.api.updateDocumentDetails(action.payload, action.id).pipe(
  //         map((response: any) => {
  //             this.notificationService.success(`Document updated successfully.`);
  //              this.router.navigateByUrl('home/resources/me');
  //             return new GetAsOfVersionStartAction(action.id);

  //         }),
  //       catchError(err => {
  //           return of(new ErrorAction(err));
  //       }));
  //     }
  //     return of('')
  //   })
  // ).subscribe()
  //       c  // // effect for update document 
  // this.action$.pipe(
  //   ofType(ResourcesActionTypes.UPDATE_DOCUMENT_START_ACTION),
  //   switchMap((action: UPDATEDOCUMENTSTARTACTION) => {
  //     if(action.callType === 'update') {
  //       alert(this.calledOnce);
  //       if(this.calledOnce) return
  //       this.calledOnce =true
  //         return this.api.updateDocumentDetails(action.payload, action.id).pipe(
  //         map((response: any) => {
  //             this.notificationService.success(`Document updated successfully.`);
  //              this.router.navigateByUrl('home/resources/me');
  //             return new GetAsOfVersionStartAction(action.id);

  //         }),
  //       catchError(err => {
  //           return of(new ErrorAction(err));
  //       }));
  //     }
  //     return of('')
  //   })
  // ).subscribe() {
  //          // // effect for update document 
  // this.action$.pipe(
  //   ofType(ResourcesActionTypes.UPDATE_DOCUMENT_START_ACTION),
  //   switchMap((action: UPDATEDOCUMENTSTARTACTION) => {
  //     if(action.callType === 'update') {
  //       alert(this.calledOnce);
  //       if(this.calledOnce) return
  //       this.calledOnce =true
  //         return this.api.updateDocumentDetails(action.payload, action.id).pipe(
  //         map((response: any) => {
  //             this.notificationService.success(`Document updated successfully.`);
  //              this.router.navigateByUrl('home/resources/me');
  //             return new GetAsOfVersionStartAction(action.id);

  //         }),
  //       catchError(err => {
  //           return of(new ErrorAction(err));
  //       }));
  //     }
  //     return of('')
  //   })
  // ).subscribe() ErrorAction(err));
  //       }  // // effect for update document 
  // this.action$.pipe(
  //   ofType(ResourcesActionTypes.UPDATE_DOCUMENT_START_ACTION),
  //   switchMap((action: UPDATEDOCUMENTSTARTACTION) => {
  //     if(action.callType === 'update') {
  //       alert(this.calledOnce);
  //       if(this.calledOnce) return
  //       this.calledOnce =true
  //         return this.api.updateDocumentDetails(action.payload, action.id).pipe(
  //         map((response: any) => {
  //             this.notificationService.success(`Document updated successfully.`);
  //              this.router.navigateByUrl('home/resources/me');
  //             return new GetAsOfVersionStartAction(action.id);

  //         }),
  //       catchError(err => {
  //           return of(new ErrorAction(err));
  //       }));
  //     }
  //     return of('')
  //   })
  // ).subscribe()
  //     }
  //     ret  // // effect for update document 
  // this.action$.pipe(
  //   ofType(ResourcesActionTypes.UPDATE_DOCUMENT_START_ACTION),
  //   switchMap((action: UPDATEDOCUMENTSTARTACTION) => {
  //     if(action.callType === 'update') {
  //       alert(this.calledOnce);
  //       if(this.calledOnce) return
  //       this.calledOnce =true
  //         return this.api.updateDocumentDetails(action.payload, action.id).pipe(
  //         map((response: any) => {
  //             this.notificationService.success(`Document updated successfully.`);
  //              this.router.navigateByUrl('home/resources/me');
  //             return new GetAsOfVersionStartAction(action.id);

  //         }),
  //       catchError(err => {
  //           return of(new ErrorAction(err));
  //       }));
  //     }
  //     return of('')
  //   })
  // ).subscribe()
  //   })
  // ).subscribe()nce);
  //       if(this.calledOnc  // // effect for update document 
  // this.action$.pipe(
  //   ofType(ResourcesActionTypes.UPDATE_DOCUMENT_START_ACTION),
  //   switchMap((action: UPDATEDOCUMENTSTARTACTION) => {
  //     if(action.callType === 'update') {
  //       alert(this.calledOnce);
  //       if(this.calledOnce) return
  //       this.calledOnce =true
  //         return this.api.updateDocumentDetails(action.payload, action.id).pipe(
  //         map((response: any) => {
  //             this.notificationService.success(`Document updated successfully.`);
  //              this.router.navigateByUrl('home/resources/me');
  //             return new GetAsOfVersionStartAction(action.id);

  //         }),
  //       catchError(err => {
  //           return of(new ErrorAction(err));
  //       }));
  //     }
  //     return of('')
  //   })
  // ).subscribe()) return
  //       this.calledOnce =  // // effect for update document 
  // this.action$.pipe(
  //   ofType(ResourcesActionTypes.UPDATE_DOCUMENT_START_ACTION),
  //   switchMap((action: UPDATEDOCUMENTSTARTACTION) => {
  //     if(action.callType === 'update') {
  //       alert(this.calledOnce);
  //       if(this.calledOnce) return
  //       this.calledOnce =true
  //         return this.api.updateDocumentDetails(action.payload, action.id).pipe(
  //         map((response: any) => {
  //             this.notificationService.success(`Document updated successfully.`);
  //              this.router.navigateByUrl('home/resources/me');
  //             return new GetAsOfVersionStartAction(action.id);

  //         }),
  //       catchError(err => {
  //           return of(new ErrorAction(err));
  //       }));
  //     }
  //     return of('')
  //   })
  // ).subscribe()rue
  //         return this.api  // // effect for update document 
  // this.action$.pipe(
  //   ofType(ResourcesActionTypes.UPDATE_DOCUMENT_START_ACTION),
  //   switchMap((action: UPDATEDOCUMENTSTARTACTION) => {
  //     if(action.callType === 'update') {
  //       alert(this.calledOnce);
  //       if(this.calledOnce) return
  //       this.calledOnce =true
  //         return this.api.updateDocumentDetails(action.payload, action.id).pipe(
  //         map((response: any) => {
  //             this.notificationService.success(`Document updated successfully.`);
  //              this.router.navigateByUrl('home/resources/me');
  //             return new GetAsOfVersionStartAction(action.id);

  //         }),
  //       catchError(err => {
  //           return of(new ErrorAction(err));
  //       }));
  //     }
  //     return of('')
  //   })
  // ).subscribe()updateDocumentDetails(action.payload, action.id).pipe(
  //         map((response: any) => {
  //             this.notificationService.success(`Document updated successfully.`);
  //              this.router.navigateByUrl('home/resources/me');
  //             return new GetAsOfVersionStartAction(action.id);

  //         }),
  //       catchError(err => {
  //           return of(new ErrorAction(err));
  //       }));
  //     }
  //     return of('')
  //   })
  // ).subscribe()
  //         }),  // // effect for update document 
  // this.action$.pipe(
  //   ofType(ResourcesActionTypes.UPDATE_DOCUMENT_START_ACTION),
  //   switchMap((action: UPDATEDOCUMENTSTARTACTION) => {
  //     if(action.callType === 'update') {
  //       alert(this.calledOnce);
  //       if(this.calledOnce) return
  //       this.calledOnce =true
  //         return this.api.updateDocumentDetails(action.payload, action.id).pipe(
  //         map((response: any) => {
  //             this.notificationService.success(`Document updated successfully.`);
  //              this.router.navigateByUrl('home/resources/me');
  //             return new GetAsOfVersionStartAction(action.id);

  //         }),
  //       catchError(err => {
  //           return of(new ErrorAction(err));
  //       }));
  //     }
  //     return of('')
  //   })
  // ).subscribe()
  //       catchError(err =>  // // effect for update document 
  // this.action$.pipe(
  //   ofType(ResourcesActionTypes.UPDATE_DOCUMENT_START_ACTION),
  //   switchMap((action: UPDATEDOCUMENTSTARTACTION) => {
  //     if(action.callType === 'update') {
  //       alert(this.calledOnce);
  //       if(this.calledOnce) return
  //       this.calledOnce =true
  //         return this.api.updateDocumentDetails(action.payload, action.id).pipe(
  //         map((response: any) => {
  //             this.notificationService.success(`Document updated successfully.`);
  //              this.router.navigateByUrl('home/resources/me');
  //             return new GetAsOfVersionStartAction(action.id);

  //         }),
  //       catchError(err => {
  //           return of(new ErrorAction(err));
  //       }));
  //     }
  //     return of('')
  //   })
  // ).subscribe() {
  //           return of(new  // // effect for update document 
  // this.action$.pipe(
  //   ofType(ResourcesActionTypes.UPDATE_DOCUMENT_START_ACTION),
  //   switchMap((action: UPDATEDOCUMENTSTARTACTION) => {
  //     if(action.callType === 'update') {
  //       alert(this.calledOnce);
  //       if(this.calledOnce) return
  //       this.calledOnce =true
  //         return this.api.updateDocumentDetails(action.payload, action.id).pipe(
  //         map((response: any) => {
  //             this.notificationService.success(`Document updated successfully.`);
  //              this.router.navigateByUrl('home/resources/me');
  //             return new GetAsOfVersionStartAction(action.id);

  //         }),
  //       catchError(err => {
  //           return of(new ErrorAction(err));
  //       }));
  //     }
  //     return of('')
  //   })
  // ).subscribe() ErrorAction(err));
  //       }));
  //     }
  //     return of('')
  //   })
  // ).subscribe()ata);

  //         //  // // effect for update document 
  // this.action$.pipe(
  //   ofType(ResourcesActionTypes.UPDATE_DOCUMENT_START_ACTION),
  //   switchMap((action: UPDATEDOCUMENTSTARTACTION) => {
  //     if(action.callType === 'update') {
  //       alert(this.calledOnce);
  //       if(this.calledOnce) return
  //       this.calledOnce =true
  //         return this.api.updateDocumentDetails(action.payload, action.id).pipe(
  //         map((response: any) => {
  //             this.notificationService.success(`Document updated successfully.`);
  //              this.router.navigateByUrl('home/resources/me');
  //             return new GetAsOfVersionStartAction(action.id);

  //         }),
  //       catchError(err => {
  //           return of(new ErrorAction(err));
  //       }));
  //     }
  //     return of('')
  //   })
  // ).subscribe()n abort method so the request can be cancelled
  //         re  // // effect for update document 
  // this.action$.pipe(
  //   ofType(ResourcesActionTypes.UPDATE_DOCUMENT_START_ACTION),
  //   switchMap((action: UPDATEDOCUMENTSTARTACTION) => {
  //     if(action.callType === 'update') {
  //       alert(this.calledOnce);
  //       if(this.calledOnce) return
  //       this.calledOnce =true
  //         return this.api.updateDocumentDetails(action.payload, action.id).pipe(
  //         map((response: any) => {
  //             this.notificationService.success(`Document updated successfully.`);
  //              this.router.navigateByUrl('home/resources/me');
  //             return new GetAsOfVersionStartAction(action.id);

  //         }),
  //       catchError(err => {
  //           return of(new ErrorAction(err));
  //       }));
  //     }
  //     return of('')
  //   })
  // ).subscribe()
  //           abort: () => {
  //             // This function is entered if the user has tapped the cancel button
  //             request.abort();

  //             // Let FilePond know the request has been cancelled
  //             abort();
  //           }
  //         };
  //       }
  //     }
  //   });
  //   this.myPond.processFile();
  // }

  clickReplaceFile() {
    this.filePresent = false;
    this.showFilePond = true;
    this.fileName = '';
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value.trim();

    this.addTagToSubmit(value);

    if (input) {
      input.value = '';
    }
    this.form.controls.tags.setValue(null);
  }

  addTagToSubmit(value) {
    if (!this.matAutocomplete.isOpen) {
      if (!this.error) {
        let index = this.selectedTags.findIndex((tag) => tag === value.trim());
        if (index === -1) {
          if (this.addTag) {
            this.store.dispatch(new LoaderShow());
            this.store.dispatch(new AddTagStartAction({ 'tag': value }));
            this.tagsList = []
          }
        }
      }
      // Reset the input value
    } else {
      let index = this.tagsList.findIndex((tag) => tag.tag === value);
      if (index === -1) {
        this.store.dispatch(new LoaderShow());
        this.store.dispatch(new AddTagStartAction({ 'tag': value }));
        this.tagsList = []
      } else {
        let index = this.selectedTags.findIndex((tag) => tag === value.trim());
        let tagData: any = this.tagsList.filter((tag) => tag.tag === value);
        if (index === -1) {
          this.selectedTags.push(tagData[0].tag);
          this.selectedTagIds.push(tagData[0]._id);
          // this.selectedTagWithId.push({value: tagData[0].tag, _id: tagData[0]._id});
          // this.selectedTagsEvent.emit(this.selectedTags);
          // this.selectedTagIdsEvent.emit(this.selectedTagIds);
          this.tagsList = []
        }
      }
    }
  }


  selected(event) {
    let index = this.selectedTags.findIndex(tag => tag === event.option.value.tag);
    if (index === -1) {

      if (!event.option.value._id) {
        this.addTagToSubmit(this.searchString);
      } else {
        this.selectedTags.push(event.option.value.tag);
        this.selectedTagIds.push(event.option.value._id)
      }
    }

    this.tagInput.nativeElement.value = '';
    this.form.controls.tags.setValue(null);
  }

  remove(tag) {
    const index = this.selectedTags.indexOf(tag);
    // this.selectedTagIds.forEach((obj, i) => {
    //   if (obj.value === tag) {
    //     this.selectedTagIds.splice(i, 1);
    //   }
    // });
    if (index >= 0) {
      this.selectedTags.splice(index, 1);
      this.selectedTagIds.splice(index, 1);
    }
  }

  onCancel() {
    this.location.back();
    if (this.documentId.length) {
      this.store.dispatch(new CancelActivityLogStartForDocument(this.docDetail.parentId || this.documentId))
    }
  }

  buttonDisabled() {
    if (
      (this.docDetail.name === this.form.value.name) &&
      (this.docDetail.description == this.form.value.description || '') &&
      (!this.showFilePond || !this.isFileReplaced)
    ) {
      return (this.isPublish) ? false : true;
    } else {
      return false;
    }
  }

  ngOnDestroy() {
    this.stopper$.next();
    this.stopper$.complete();
  }
}
